export function getPagesCount(total: number, itemsPerPage: number) {
    const evenPagesCount = Math.floor(total / itemsPerPage);
    const reminder = total % itemsPerPage;

    if (reminder > 0) {
        return evenPagesCount + 1;
    } else {
        return evenPagesCount;
    }
}

export function getStartIndex(page: number, itemsPerPage: number) {
    return (page - 1) * itemsPerPage;
}

export function getEndIndex(page: number, itemsPerPage: number, total: number) {
    const startIndex = getStartIndex(page, itemsPerPage);
    return Math.min(total, startIndex + itemsPerPage);
}

export function fixLastPage(lastPage: number, total: number, itemsPerPage: number) {
    const maxPagesCount = getPagesCount(total, itemsPerPage);

    if (lastPage > maxPagesCount) {
        return maxPagesCount;
    } else {
        return lastPage;
    }
}
